export default "__VITE_ASSET__mQJ9WnUG__"